<script lang="ts" context="module">
    type A = unknown
    type E = unknown
    type T = Effect.Effect<A, E, never>
</script>

<script lang="ts" generics="A, E, T extends Effect.Effect<A, E, never>">
    import { friendlyError } from "@utils/utilities/friendly-error"
    import { Toasts } from "@utils/utilities/toasts"
    import type { Effect } from "effect"

    import { resultify } from "@utils/utilities/effect/result"

    import type { IconAnimated } from "@components/material/Icon.module"
    import ContextMenuLink from "./ContextMenuLink.svelte"

    export let icon: IconAnimated | null
    export let toggled = false
    /**
     * if effect is false, it means nothing will happen. easier to handle disable stuff
     */
    export let effect: T | undefined | false | null = undefined
    export let passToContext = true

    export let onerror: (error: E) => void = (err) => Toasts.error(friendlyError(err))
    export let onsuccess: (result: A) => void = () => {}

    $: cb =
        effect &&
        !!onerror &&
        !!onsuccess &&
        (() =>
            resultify(effect).then((res) => {
                if (res.isOk) return onsuccess(res.value)
                console.error(res.error)
                return onerror(res.error)
            }))
</script>

<ContextMenuLink {icon} {passToContext} {toggled} cb={cb || (() => {})}><slot /></ContextMenuLink>
